<template>
	<div>
        <div class="row">
            <el-card class="pb-2 pt-3" shadow="always" :body-style="{ padding: '0px'}" style="width:100%;">
             
                <div class="row">
                    <div class="col-md-2">
                        <el-button size="mini" @click="$router.push('/performance-report/intro')"><i class="fa fa-angle-left"></i></el-button>
                    </div>
                    <div class="col-md-8"><h4 class="text-center">PENCAPAIAN PERTUMBUHAN OUTLET</h4></div>
                    <div class="col-md-2 text-right">
                        <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        <el-button size="mini" @click="$router.push('/performance-report/sales-losses')"><i class="fa fa-angle-right"></i></el-button>
                    </div>
                </div>

                <div class="col-md-12">
                    <el-tabs v-model="activeName" @tab-click="handleTabClick">
                        <el-tab-pane name="first">
                            <span slot="label"><i class="fa fa-gas-pump"></i>&nbsp;&nbsp;<b>FUEL RETAIL BUSINESS</b></span>
                            <div>
                                <TabContent/>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="second">
                            <span slot="label"><i class="fa fa-gas-pump"></i>&nbsp;&nbsp;<b>NON FUEL RETAIL BUSINESS</b></span>
                            <div>
                                <TabContentNonFuel/>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>

            </el-card>
    </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
// TinyMCE
//import Editor from '@tinymce/tinymce-vue'
import TabContent from '@/views/pages/LaporanKinerja/PencapaianPertumbuhanOutletTabContent.vue'
import TabContentNonFuel from '@/views/pages/LaporanKinerja/PencapaianPertumbuhanOutletTabContentNonFuel.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
        TabContent,
        TabContentNonFuel,
		//ReportParamSelect,
        //'editor': Editor,
	},

	data() {
		return {
            activeName: 'first',
            
            /*
            tinymce: {
                init: {
                    //height: 500,
                    apiKey: 'j19flohjejcv1yvg1pqafkelpy8in88meplt8o175hdzpimo',
                    menubar: true,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar:
                        'undo redo | formatselect | bold italic underline backcolor | \
                        alignleft aligncenter alignright alignjustify | \
                        bullist numlist outdent indent | removeformat | help'
                },
                example1 : `<h3 style="color:#FF7711;"><b>SPBU KSO</b></h3>                     
                        <p style="color:#2F5597;"><b>Adanya penambahan kerjasama KSO TAC Ytd Mei sebagai berikut : </b></p>
                        <ol style="color:#2F5597;">
                            <li><b>SPBU Nasution – Medan</b></li>
                            <li><b>SPBU Bandar Ratu – Bengkulu</b></li>
                            <li><b>SPBU Kota Malang – Bandung</b></li>
                            <li><b>SPBU Panglima Utar Kotawaringin Barat – Kalteng</b></li>
                            <li><b>SPBU Wonosari – Gorontalo</b></li>
                            <li><b>SPBU Bitung - Manado</b></li>
                        </ol>
                `,
                example2 : `<h3 style="color:#FF7711;"><b>SPBU TOL & NON TOL</b></h3>
                        <ul style="color:#2F5597;">
                            <li><b>Masih berprogress terkait dalam tahapan pembangunan untuk SPBU Universitas Padjajaran</b></li>
                            <li><b>Masih berprogress terkait dalam tahap negosiasi untuk SPBU Modular di KM 456 A Semarang – Jawa Tengah</b></li>
                        </ul>
                `,
                example3 : `<h3 style="color:#FF7711;"><b>PERTASHOP</b></h3>
                        <ol style="color:#2F5597;">
                            <li><b>Belum adanya penambahan Pengalihan skema Pertashop COCO menjadi CODO sebanyak 380 unit.</b></li>
                            <li><b>Tahun 2022 – Mei 2023 telah terjual unit modular Pertashop DODO sebanyak  87 unit.</b></li>
                            <li><b>Total terjual selama 2020 – Mei 2023 sebanyak 2189 unit.</b></li>
                        </ol>
                `,
            }
            */
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');

        if(!this.isLocalPeriodSet()) {
            console.log('period is not set')
            //this.$router.push('/performance-report/')
            //this.$route.go('/performance-report/')
        } else {
            console.log('period set')
        }
    },
    methods: {
        handleTabClick(tab, event) {
        console.log(tab, event);
      }
    },
}
</script>